import { FEditableGridColumn, FEditableGridPayload, FEditableGridRow } from './types';

export const makeRid = () => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return `row_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};

export const createEmptyRow = (gform: FEditableGridColumn[]): FEditableGridRow => {
  const row: FEditableGridRow = { _rid: makeRid(), _state: 'new', _errors: {}, _selected: false };
  gform.forEach((col) => { if (!col.hidden) row[col.id] = col.defaultValue ?? ''; });
  return row;
};

export const validateRows = (gform: FEditableGridColumn[], rows: FEditableGridRow[]) => {
  let ok = true;
  const next = rows.map((row) => {
    if (row._state === 'deleted') return row;
    const errors: Record<string, string> = {};
    gform.forEach((col) => {
      if (col.hidden) return;
      if (col.req && (row[col.id] === undefined || row[col.id] === null || row[col.id] === '')) {
        errors[col.id] = `${col.label} is required`;
      }
    });
    if (Object.keys(errors).length > 0) ok = false;
    return { ...row, _errors: errors };
  });
  return { ok, rows: next };
};

export const compileRows = (rows: FEditableGridRow[]): FEditableGridPayload => {
  const active = rows.filter((row) => row._state !== 'deleted');
  const rcd = active.map((row) => {
    const out: Record<string, any> = {};
    Object.keys(row).forEach((key) => { if (!key.startsWith('_')) out[key] = row[key]; });
    return out;
  });
  return { rcd, raw: active };
};
